<template>
  <div>
    <div v-if="windowWidth >= 500" class="box indexBar">
      <div :class="navBarFixed == true ? 'navBarWrap' :''">
        <div class="header">
        <div class="logo_img" @click="handleSelect('1')">
          <div style="display:flex; align-items: center; float:left; height: 60px;">
            <div class="headerImgBox">
              <img v-if="!navBarFixed" id="header-img" src="../../static/common/adv-logo.png">
              <img v-if="navBarFixed" id="header-img" src="../../static/common/adv-logo.png" alt="">
            </div>
          </div>
        </div>
        <div class="headerRight">
          <div id="menu_index">
            <!-- web端菜单导航 -->
            <el-menu 
              v-if="windowWidth >= 500" 
              :default-active="activeIndex" 
              class="el-menu-demo" 
              menu-trigger="click" 
              text-color="#fafafa"
              style="height: 60px; border:0;" 
              mode="horizontal" 
              @select="handleSelect">
              <el-menu-item index="5" class="header-title">
                <span>ADVERTISERS</span>
                <img v-if="activeIndex == 1" src="../../static/index/selectRed.png" alt="">
              </el-menu-item>
              <el-menu-item index="2" class="header-title">
                <span>AFFILIATES</span>
                <img v-if="activeIndex == 2" src="../../static/index/selectRed.png" alt="">
              </el-menu-item>
              <el-menu-item index="3" class="header-title selectBox">
                <span>EVENT & RESOURCE</span>
                <img v-if="activeIndex == 3" src="../../static/index/selectRed.png" alt="">
                <div class="cityBox">
                  <span @click="eventBus('#EVENT')">EVENT</span>
                  <span @click="eventBus('#RESOURCE')">RESOURCE</span>
                </div>
              </el-menu-item>
              <el-menu-item index="4" class="header-title">
                <span>CONTACT</span>
                <img v-if="activeIndex == 4" src="../../static/index/selectRed.png" alt="">
              </el-menu-item>
              <!-- <el-menu-item index="5" class="header-title">
                <span>联系客服</span>
                <img v-if="activeIndex == 5" src="../../static/index/selectRed.png" alt="">
              </el-menu-item> -->
            </el-menu>
          </div>
          <div class="line">|</div>
          <p class="signUp transformBtn" @click="handleSelect('4')">SIGN UP</p>
        </div>
      </div>
      <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
        <p style="font-size: 0.625em; font-weight: bold">TOP</p>
      </div>
      </div>
    </div>
    <div v-if="windowWidth<500 && toScroll" class="wapBar">
      <img @click="control = !control" class="wapIcon" src="@static/wap/index/wapIcon.png" alt="">
      <img class="wapLogo" @click="handleSelect('5')" src="@static/common/adv-logo.png" alt="">
      <div class="wapBox" v-if="control">
        <div class="wapContent">
          <div @click="handleSelect('5')">ADVERTISERS</div>
          <div @click="handleSelect('2')">AFFILIATES</div>
          <div>
            <span style="margin-right: 5px;" @click="handleSelect('3')">EVENT & RESOURCE</span>
            <i v-if="!showLabel" @click.stop="showLabel = !showLabel" class="el-icon-arrow-down"></i>
            <i v-else @click.stop="showLabel = !showLabel" class="el-icon-arrow-up"></i>
            <div v-if="showLabel" class="showLabel">
              <span @click="eventBus('#EVENT')">EVENT</span>
              <span @click="eventBus('#RESOURCE')">RESOURCE</span>
            </div>
          </div>
          <div @click="handleSelect('4')">CONTACT</div>
        </div>
      </div>
      <div class="shadow" v-if="control" @click="control = !control"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Layout",
    data() {
      return {
        activeIndex: '1',
        scroll: '',
        timer: '',
        navBarFixed: false,
        windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
        toScroll:true,
        showLabel: false,
        control: false,
      };
    },
    created(){
      if(sessionStorage.getItem('key')){
        this.activeIndex = sessionStorage.getItem('key');
      }else{
        this.activeIndex = '1';
      }
      // 传递key值给父组件App.vue
      this.$emit('getKey', this.activeIndex);
    },
    mounted() {
      var that = this;
      // 把window.onresize事件挂在到mounted函数上
      window.onresize = () => {
        return (() => {
          window.fullWidth = document.documentElement.clientWidth;
          that.windowWidth = window.fullWidth; // 宽
        })()
      };
    },
    computed:{
      MenuKey(){
        return this.$store.state.menuKey;
      }
    },
    watch: {
      windowWidth(val){
        let that = this;
        console.log("实时屏幕宽度：",val, that.windowWidth );
      },
      MenuKey(val){
        this.activeIndex = val;
        sessionStorage.setItem('key',val);
        this.$emit('getKey', val);
      }
    },
    methods: {
      handleSelect(key) {
        this.$emit('getKey', key);
        sessionStorage.setItem('key',key);
        this.$store.commit('setMenuKey',key);
        switch (key) {
          case '1':
            this.activeIndex = key;
            this.$router.push({
              name: "Index"
            });
            this.$store.commit('setAdvertiser','')
            break;
          case '2':
            this.activeIndex = key;
            this.$router.push({
              name:'Aboutus'
            })
            break;
          case '3':
            this.activeIndex = key;
            this.$router.push({
              name: "Details"
            });
            break;
          case '4':
            this.activeIndex = key;
            this.$router.push({
              name: "signup"
            });
            break;
          case '5':
            this.activeIndex = '1';
            this.$emit('getKey', '1');
            sessionStorage.setItem('key','1');
            this.$store.commit('setMenuKey','1');
            this.$router.push({
              name: "Index"
            });
            this.$store.commit('setAdvertiser','#vital');
            this.backTop();
            break;
        }
        this.control = false;
      },
      handleScroll() {
        this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
        if(this.scroll > 50 ){
          this.navBarFixed = true;
          this.toScroll = false;
          this.control = false;
        }else{
          this.navBarFixed = false;
          this.toScroll = true;
        }
      },
      backTop() { //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
        this.timer = setInterval(() => {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5)
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          if (osTop === 0) {
            clearInterval(this.timer)
          }
        }, 10)
      },
      eventBus(e){
        this.$store.commit('setControlEventBus',e);
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
  }
</script>

<style lang="less" scoped>
  .box{
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 20px 0;
  }
  .indexBar{
    background-color: rgba(255, 255, 255, 0.43);
  }
  .logo_img {
    float: left;
    cursor: pointer;
  }

  #back_to_top {
    position: fixed;
    bottom: 50px;
    right: 30px;
    cursor: pointer
  }

  .header-title {
    font-size: 14px;
    span{
      color: #E02328;
    }
  }
  .selectBox{
    position: relative;
    .cityBox{
      position: absolute;
      top: 155%;
      left: 50%;
      transform: translate(-50%,-50%);
      box-sizing: border-box;
      padding: 20px 10px 10px;
      // background-color: rgba(249, 2, 2, 0.43);
      display: none;
      span{
        color: #E02328;
        width: 80px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 10px auto;
      }
    }
  }
  .selectBox:hover{
    .cityBox{
      display: block;
    }
  }

  #menu_index {
    height: 100%;
  }

  .header {
    margin: auto;
    width: 1135px;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .headerImgBox {
    width: 180px;
    height: auto;
  }
  #header-img {
    width: 180px;
    height: auto;
    float: left;
    margin: 0 auto;
  }
  .el-menu-item img{
    width: 45%;
    height: 2px;
    position: absolute;
    bottom:0px;
  }
  .header-title:focus {
    outline: none;
  }
  .headerRight{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .line{
      color: #E11F27;
      margin-right: 20px;
    }
    .signUp{
      width: 120px;
      height: 40px;
      border-radius: 8px;
      background-color: #010101;
      color: #fff;
      font-size: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: 0.3s;
    }
  }
  .navBarWrap {
    width: 100%;
    position:fixed;
    top:0;
    left: 50%;
    transform: translate(-50%,0);
    z-index:999;
    background-color: #fff;
    // transition: all .5s;
  }
  ::v-deep{
    .el-menu-item{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
    }
    // 去掉element-ui menu 原背景色
    .el-menu{
      background-color: transparent;
    }
    // 去掉element-ui menu划过背景色
    .el-menu-item:focus, .el-menu-item:hover{
      background-color: transparent !important;
    }
    // 去掉element-ui menu点击背景色
    .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover{
      background-color: transparent !important;
    }
    // 去掉element-ui导航栏底部边框线
    .el-menu--horizontal>.el-menu-item{
      border-bottom: none;
    }
  } 
  .wapBar{
    width: 100%;
    height: 40px;
    position: fixed;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    .wapIcon{
      width: 20px;
      margin-left: 8px;
      position: absolute;
      top: 10px;
      left: 5px;
    }
    .wapLogo{
      position: absolute;
      width: 100px;
      margin: 20px auto 0;
      top: 0%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
    .wapBox{
      position: fixed;
      width: 50%;
      height: 100%;
      top: 0%;
      left: 0%;
      background: linear-gradient(180deg, #E11F27 0%, #AE2025 100%);
      z-index: 10;
      .wapContent{
        width: 80%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        color: #fff;
        margin-top: 10px;
        font-size: 12px;
        div{
          text-align: left;
          margin-bottom: 10px;
          .showLabel{
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            margin-left: 10px;
            line-height: 28px;
          }
        }
      }
    }
    .shadow{
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      position: fixed;
      top: 0%;
      left: 0%;
      z-index: 9;
    }
  }
</style>